webpackJsonp([218200519336295],{

/***/ 1914:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientProtocolEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"PatientProtocol","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-patient-protocol-edge-02311b736c0ee9d4bc02.js